export default {"src":"/_next/static/media/valorant-active.5b9fc6d9.svg","height":315,"width":315,"blurWidth":0,"blurHeight":0};